export default {
    onlineStatus: {
        api: true,
        web: true,
    },

    searchQuery: '',
    filters: {
        selected_events: [],
        only_approved_entries: true,
    },

    upcomingEvents: null,
    searchCache: null,

    searchInProgress: false,

    selectedPerson: null,
}
